import ResourcesFilters from "./ResourcesFilters";

export default ResourcesFilters;
